import { render } from "./BasePagination.vue?vue&type=template&id=00741a2a&scoped=true"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=00741a2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00741a2a"]])

export default __exports__